module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.adventure) ? _c('breadcrumbs', {
    attrs: {
      "adventure": _vm.adventure,
      "adventureId": _vm.adventureId,
      "chapter": _vm.selectedChapter,
      "chapterId": _vm.selectedChapterId
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "mdl-grid adv-content",
    staticStyle: {
      "background-color": "white",
      "margin-top": "20px"
    },
    attrs: {
      "id": "page-adventure-edit"
    }
  }, [(_vm.adventure) ? _c('div', {
    staticClass: "mdl-grid mdl-cell--12-col"
  }, [_c('div', {
    staticClass: "mdl-cell--6-col mdl-cell--12-col-tablet"
  }, [(_vm.user) ? _c('dropzone-firebase', {
    attrs: {
      "folder": _vm.user.uid + '/' + _vm.adventureId,
      "file-name": "bg",
      "bg-image": _vm.adventure.cover
    },
    on: {
      "upload": _vm.coverUpdate
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell--6-col mdl-cell--12-col-tablet mdl-grid "
  }, [_c('div', {
    staticClass: "mdl-cell--12-col-tablet mdl-grid",
    staticStyle: {
      "background-color": "white",
      "text-align": "left"
    }
  }, [_c('h5', {
    staticClass: "mdl-cell--12-col"
  }, [_vm._v("Edit Adventure")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-cell--12-col",
    class: {
      'is-dirty': _vm.adventure.name
    }
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "sample1"
    },
    domProps: {
      "value": _vm.adventure.name
    },
    on: {
      "input": _vm.updateName
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample1"
    }
  }, [_vm._v("Name...")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-cell--12-col",
    class: {
      'is-dirty': _vm.adventure.description
    }
  }, [_c('textarea', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "rows": "4",
      "id": "sample5"
    },
    domProps: {
      "value": _vm.adventure.description
    },
    on: {
      "input": _vm.updateDescription
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "sample5"
    }
  }, [_vm._v("Description...")])]), _vm._v(" "), _c('h5', {
    staticClass: "mdl-cell--12-col"
  }, [_vm._v("Chapters")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-button mdl-button--raised  mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "to": ('/editor/' + _vm.adventureId + '/chapters')
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("collections_bookmark")]), _vm._v(" Edit Chapters")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-button mdl-button--raised  mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "to": ('/editor/play/' + _vm.adventureId)
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("play_arrow")]), _vm._v(" Play Adventure")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-button mdl-button--raised mdl-js-button mdl-js-ripple-effect",
    staticStyle: {
      "margin": "5px"
    },
    on: {
      "click": function($event) {
        _vm.showDialog('deleteAdventure')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("delete")]), _vm._v("Delete Adventure")])], 1)])]) : _c('div', {
    staticClass: "mdl-grid mdl-cell--12-col"
  }, [_c('h3', {
    staticClass: "mdl-cell--12-col",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Adventure Deleted")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-button mdl-button--raised  mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "to": ('/editor/')
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("keyboard_arrow_left")]), _vm._v("Back to My Adventures")])], 1)]), _vm._v(" "), _c('dialog', {
    staticClass: "mdl-dialog deleteAdventure"
  }, [_c('div', {
    staticClass: "mdl-dialog__title"
  }, [_vm._v("Delete this adventure")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__actions mdl-dialog__actions"
  }, [_c('button', {
    staticClass: "mdl-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteAdventure
    }
  }, [_vm._v("DELETE")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button close",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("CANCEL")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-dialog__content"
  }, [_c('p', [_vm._v("\n        Are you sure you want to delete this adventure? "), _c('br'), _vm._v("\n        This action cannot be undone.\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59b35bd9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionAdventureEdit.vue
// module id = 310
// module chunks = 0